// extracted by mini-css-extract-plugin
module.exports = {"highlight":"style_highlight__3tpJI"};